module.exports = __webpack_public_path__ + "static/media/checkbox.c3d205f4.svg";